export default __webpack_public_path__ + "static/media/Autokritigallery_25.220ebe28.jpg";